export const coordinationQueryKeys = {
  meeting: (meetingId: string) =>
    ['coordination', 'meeting', meetingId] as const,
  preconditions: (jobId: string) =>
    ['coordination', 'preconditions', jobId] as const,
  processes: (jobId: string) => ['coordination', 'processes', jobId] as const,
  processDetail: (jobId: string, coordinationProcessId: string) =>
    ['coordination', 'process-detail', jobId, coordinationProcessId] as const,
};
